import styled, { css } from 'styled-components';
import { hexToRgb } from '~/shared';
import helpColorBg from '../../assets/images/help_color_bg.svg';

const StyledContainer = styled.div`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	gap: 10px;
`;

const StyledColorWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 14px;
	height: 14px;
	background-image: url(${helpColorBg});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
`;

const StyledColor = styled.div<{ $color: string }>((props) => {
	const { $color } = props;
	const rgbColor = hexToRgb($color);
	const shadowColor = `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.75)`;

	return css`
		width: 8px;
		height: 8px;
		background: radial-gradient(
				50% 50% at 50% 50%,
				rgba(255, 255, 255, 0.5) 0%,
				rgba(255, 255, 255, 0) 100%
			),
			${props.$color};
		border: 1px solid ${props.$color};
		box-shadow: 0px 0px 4px ${shadowColor};
		border-radius: 50%;
	`;
});

export { StyledColor, StyledColorWrapper, StyledContainer };
